import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface IProps {
    businessId: string;
    businessType: string;
    documentTokens: string[]
}

export const useSaveMissingDoc = (onError: (code: number, msg: string) => void) => {
  const { customerId } = useStore(state => state.user);
  return useMutation(
    'useSaveMissingDoc',
    async (data: IProps) => {
      const res = await httpService.post(
        `${BASE_URL}/api/v1/user/${customerId}/missingBusinessDocs`,
        {
          businessId: data.businessId,
          type: data.businessType,
          documentTokens: data.documentTokens,
        },
      );
      return res.data;
    },
    {
      retry: 0,
      onError: (e:IServerErrorResponse) => {
        const { localizedMessage, code } = flattenServerErrorResponse(e);
        onError(code, localizedMessage);
      },
    },
  );
};
